export enum KeyCodes {
  enter = 'Enter',
  backspace = 'Backspace',
}
